import ExifWorker from "workerize-loader!@/services/exif.js"

export class ExifWorkerPool {
  constructor(count = 1) {
    this.workerIndex = 0
    this.workers = []

    // Don't create workers in IE, since I could not get exifr to work.
    if (/MSIE|Trident/.test(navigator.userAgent)) { return }

    // limit number of workers to number of logical cores
    const maxWorkers = navigator.hardwareConcurrency
    if (maxWorkers) {
      count = Math.min(count, maxWorkers)
    }

    for (let i = 0; i < count; i++ ) {
      this.workers.push(new ExifWorker())
    }
  }

  async getExif(...args) {
    return this.getWorker()?.getExif(...args)
  }
  getWorker() {
    // round robin from a pool of web workers
    if (this.workerIndex >= this.workers.length) { this.workerIndex = 0 }
    return this.workers[this.workerIndex++]
  }
  terminate() {
    this.workers.forEach(w => w.terminate())
  }
}
